import { connect } from 'react-redux';
import { deleteDraftRequest } from 'drafts/containers/draft-actions';
import { unlockLockRequest, discardLockRequest } from './publish-steps-actions';
import ErrorSummary from '../components/error-summary';

const mapStateToProps = state => ({
  currentStatus: state.currentStatus.operationInfo,
  error: state.currentStatus.error,
  isLoading: state.currentStatus.isLoading,
  menuVisible: state.header.menuVisible,
  isDeletingDraft: state.drafts.isDeletingDraft,
});

const mapDispatchToProps = {
  unlockLockRequest,
  discardLockRequest,
  deleteDraftRequest,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ErrorSummary);
